import {spac} from 'constants/url';
import useUpdate from '../../../components/hooks/useUpdate';
import {EditingOptions} from '../../../components/grid-dx/types';

function useUpdateSpac() {
  const updateSpac = useUpdate(spac);
  return (editingOptions: EditingOptions) => updateSpac(editingOptions);
}

export default useUpdateSpac;
